import JsonURL from '@jsonurl/jsonurl';
import { v4 as uuid } from 'uuid';
export function constructSearchURL(options) {
    const { where, query, modifiers, path = 'all-documents', forceRemount = true } = options;
    const sanitizedQuery = (query === null || query === void 0 ? void 0 : query.trim()) || '';
    const url = new URLSearchParams();
    const stringifiedFilters = where ? JsonURL.stringify(where, { AQF: true }) : '';
    const stringifiedModifiers = modifiers ? JsonURL.stringify(modifiers, { AQF: true }) : '';
    if (stringifiedModifiers) {
        url.set('modifiers', stringifiedModifiers);
    }
    if (stringifiedFilters) {
        url.set('filters', stringifiedFilters);
    }
    if (sanitizedQuery) {
        url.set('query', sanitizedQuery);
    }
    if (forceRemount) {
        url.set('_cacheKey', uuid());
    }
    const stringifiedUrl = url.toString();
    return `/${path}?${stringifiedUrl}`;
}
